import React, { useEffect, useReducer, useState, useCallback, useRef } from 'react';
import styled from '@emotion/styled';
import {singlePost} from './services/common.service'
import { WPSingleJobItem } from './typings';
import { Header } from './components/Header/Header';
import { SingleJobDescription } from './components/SingleJobDescription/SingleJobDescription';
import * as styles from './AppSingle.module.scss';
import { SocialMedia } from './components/SocialMedia/SocialMedia';
import Loading from './components/Loading';
import { useParams } from 'react-router-dom';
import { SocialMediaMobile } from './components/SocialMediaMobile/SocialMediaMobile';
import { SimilarOpportunities } from './components/SimilarOpportunities/SimilarOpportunities';

const { __ } = window.wp.i18n;

function App() {
  const [singleJob, setSingleJob] = useState<WPSingleJobItem>();
  const [loading, setLoading] = useState<boolean>(true);
  const [showMobile, setShowMobile] = useState<boolean>();
  const { id } = useParams();

  const [jobId, setJobId] = useState<string | null>(null);

  useEffect(() => {
    const url = window.location.href;
    const extractedJobId = getJobIdFromUrl(url);
    setJobId(extractedJobId);
  }, []);

  // function getJobIdFromUrl(url:string) {
  //   const regex = /\/job\/([a-zA-Z0-9_]+)/;
  //   const match = url.match(regex);
  //   return match ? match[1] : null;
  // }

  function getJobIdFromUrl(url:string) {
    try {
        const urlObject = new URL(url);  // Create a URL object
        const pathSegments = urlObject.pathname.split('/');  // Split the path into segments

        // Find the index of 'jobs' and return the next segment
        const jobsIndex = pathSegments.indexOf('jobs');
        if (jobsIndex !== -1 && pathSegments[jobsIndex + 1]) {
            return pathSegments[jobsIndex + 1];
        } else {
            throw new Error('Job ID not found in URL');
        }
    } catch (error) {
        console.error('Error extracting Job ID:', error);
        return null;
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      if (!jobId) return; // Prevent fetching if jobId is null
      setLoading(true);
      try {
        const response = await singlePost(jobId);
        setSingleJob(response);
      } catch (err) {
        console.error('Error fetching listings:', err);
      } finally {
        setLoading(false);
      }
    };

    if (jobId) fetchData(); // Call the async function only if jobId exists
  }, [jobId]);

  useEffect(() => {
    document.body.classList.add(styles.body);

    return () => {
      document.body.classList.remove(styles.body);
    };
  }, []);

  const headerTopBar = document.querySelector('.header-topbar-wrapper') as HTMLElement;
  if(headerTopBar) {
    headerTopBar.style.paddingBottom = "0";
    headerTopBar.style.zIndex = "105";
  }

  const headerMobile = document.querySelector('.header-mobile') as HTMLElement;

  const fixedMobileNav = document.querySelector(".sub-navigation-wrapper") as HTMLElement;
  if(fixedMobileNav) fixedMobileNav.style.position = "static";
  if(window.matchMedia("(max-width: 1199px)").matches) fixedMobileNav.style.display = "none";

  const fixedNavSticky = document.querySelector(".sub-navigation.fixed") as HTMLElement;
  if(fixedNavSticky) fixedNavSticky.style.position = "static";

  const fixedNav = document.querySelector(".sub-navigation") as HTMLElement;
  if(fixedNav) fixedNav.style.position = "relative";
  if(fixedNav) fixedNav.style.boxShadow = "0 2px 50px 0 rgba(0,0,0, 0.1)";

  const fixedMobileHeader = document.querySelector(".header-mobile") as HTMLElement;
  if(fixedMobileHeader) fixedMobileHeader.style.position = "static";

  //Show mobile
  useEffect(() => {
    const showFilters = () => {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setShowMobile(false);
        } else {
            setShowMobile(true);
        }

        if (window.matchMedia('(min-width: 992px) and (max-width: 1199px)').matches) {
          if(headerMobile) headerMobile.style.display = "block";
        } else {
          if(headerMobile) headerMobile.style.display = "none";
        }


        if (window.matchMedia("(max-width: 1199px)").matches) {
          fixedMobileNav.style.display = "none";
        } else {
          fixedMobileNav.style.display = "block";
        }
    };

    // Set the initial placeholder
    showFilters();
    // Add an event listener for window resize
    window.addEventListener('resize', showFilters);
    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', showFilters);
  }, []);


  return (
    <div className={styles['container-job-detail']} id="container-cjs-detail">
      {loading ?
        <Loading/>
        : <>
          {singleJob && <Header singleJob={singleJob}/>}
          {singleJob ? (
              <SingleJobDescription htmlContent={singleJob?.description} />
          ) : (
              <div className="container">
                <p className={styles.jobLoadingFailedError}>{__('We couldn\'t load the job at this time.', 'cg-jobs')}</p>
              </div>
          )}
          {showMobile ? <SocialMediaMobile id={singleJob?.id ?? ""} title={singleJob?.title ?? ""} location={singleJob?.location ?? ""}/> : <SocialMedia id={singleJob?.id ?? ""} title={singleJob?.title ?? ""} />}

          <SimilarOpportunities id={singleJob?.id} professionalCommunity={singleJob?.professional_communities} experienceLevel={singleJob?.experience_level} contractType={singleJob?.contract_type} />
          </>
      }
    </div>
  );
}

export default App;
